import React from 'react';

import styles from '@/components/global/pills/pill-amenities.module.scss';

interface Props extends React.HTMLAttributes<HTMLElement> {
  label?: string;
}

const PillAmenities = (props: Props): React.JSX.Element | null => {
  return (
    <div className={styles['pill-amenities']}>
      {props.children}
      <span className={styles.label}>{props.label}</span>
    </div>
  );
};

export default PillAmenities;
